<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="供应商管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="供应商名称">
          <el-input
            v-model="params.SupplierName"
            placeholder="请输入供应商名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model="params.ContactPhone"
            placeholder="请输入联系电话"
            clearable
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="OrderId"
          label="序号"
          align="center"
          width="60"
        />

        <el-table-column prop="SupplierName" label="供应商名称" />
        <el-table-column prop="ContactName" label="联系人" />
        <el-table-column prop="ContactPhone" label="联系电话" />

        <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="StoreName"
          label="所属门店"
          v-if="$permission.isStore() == false"
        />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/wh/supplier").default,
      params: {
        SupplierName: "",
        ContactPhone: "",
        State: null,
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>